import axios from "axios";
import React, { useEffect, useState } from "react";

import {
  faCaretDown,
  faCaretUp,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import "./styles.scss";

import "react-circular-progressbar/dist/styles.css";

import Navbar from "../../Components/Navbar";

const LeaderboardPage = (props) => {
  const token = localStorage.getItem("JWT");

  const [filteredItems, setFilteredItems] = useState([]);
  const [triangleButton, setTriangleButton] = useState("FCU rank top");
  const [triangleClass, setTriangleClass] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [deleteEmployee, setDeleteEmployee] = useState(false);
  const [eliminationDatas, setEliminationDatas] = useState([]);
  const [controlDatas, setControlDatas] = useState([]);
  const [squadronDatas, setSquadronDatas] = useState([]);
  const [vanduulDatas, setVanduulDatas] = useState([]);
  const [pirateDatas, setPirateDatas] = useState([]);
  const [activeButton, setActiveButton] = useState("elimination");
  const [titlesArray, setTitlesArray] = useState([
    "FCU RANK",
    "PLAYER",
    "KILLS",
    "KILL / DEATH",
    "SCORE / MINUTE",
    "PLAY TIME",
    "RSI RANK",
  ]);
  const [workData, setWorkData] = useState([]);

  const triangleClick = (title, direction) => {
    setTriangleButton(title + direction);
    const newTriangleClass = title + direction;
    setTriangleClass(newTriangleClass);
    // console.log("triangleButton :", triangleButton);
  };

  useEffect(() => {
    axios({
      method: "get",
      url: `${process.env.REACT_APP_API_URL}api/getAllEliminationLB`,
      headers: {
        Authorization: `Bearer ${token}`, // Ajouter le token JWT dans les en-têtes de la requête
      },
    })
      .then((res) => {
        setEliminationDatas(res.data);
        setWorkData(res.data);
      })
      .catch((err) => {
        console.log(err);
      });

    //------------- REMPLACER PAR FETCH SQUADRON DATAS ----------------------
    // setVanduulDatas([
    //   {
    //     handle: "RealBadman_972",
    //     rank: "179",
    //     KD: 0.91,
    //     kills: 102,
    //     playTime: "02:13",
    //     scoreMinute: 569.63,
    //     fcuRank: 42.92899974280509,
    //     rang: 16,
    //   },
    //   {
    //     handle: "Rethiel",
    //     rank: "114",
    //     KD: 0.61,
    //     kills: 139,
    //     playTime: "02:01",
    //     scoreMinute: 749.41,
    //     fcuRank: 42.340110261597296,
    //     rang: 17,
    //   },
    //   {
    //     handle: "N0G",
    //     rank: "200+",
    //     KD: 0.97,
    //     kills: 107,
    //     playTime: "01:11",
    //     scoreMinute: 756.84,
    //     fcuRank: 41.233307521755385,
    //     rang: 18,
    //   },
    //   {
    //     handle: "NekinoxBlaz",
    //     rank: "199",
    //     KD: 2.97,
    //     kills: 1,
    //     playTime: "16:18",
    //     scoreMinute: 848.01,
    //     fcuRank: 231.28592839578002,
    //     rang: 2,
    //   },
    //   {
    //     handle: "Darkragess",
    //     rank: "36",
    //     KD: 2.44,
    //     kills: 2,
    //     playTime: "26:28",
    //     scoreMinute: 1024.91,
    //     fcuRank: 224.4406818056869,
    //     rang: 3,
    //   },
    // ]);

    axios({
      method: "get",
      url: `${process.env.REACT_APP_API_URL}api/getAllControlLB`,
      headers: {
        Authorization: `Bearer ${token}`, // Ajouter le token JWT dans les en-têtes de la requête
      },
    })
      .then((res) => {
        setControlDatas(res.data);
      })
      .catch((err) => {
        console.log(err);
      });

    axios({
      method: "get",
      url: `${process.env.REACT_APP_API_URL}api/getAllSquadronLB`,
      headers: {
        Authorization: `Bearer ${token}`, // Ajouter le token JWT dans les en-têtes de la requête
      },
    })
      .then((res) => {
        setSquadronDatas(res.data);
      })
      .catch((err) => {
        console.log(err);
      });

    axios({
      method: "get",
      url: `${process.env.REACT_APP_API_URL}api/getAllVanduulLB`,
      headers: {
        Authorization: `Bearer ${token}`, // Ajouter le token JWT dans les en-têtes de la requête
      },
    })
      .then((res) => {
        setVanduulDatas(res.data);
      })
      .catch((err) => {
        console.log(err);
      });

    axios({
      method: "get",
      url: `${process.env.REACT_APP_API_URL}api/getAllPirateLB`,
      headers: {
        Authorization: `Bearer ${token}`, // Ajouter le token JWT dans les en-têtes de la requête
      },
    })
      .then((res) => {
        setPirateDatas(res.data);
      })
      .catch((err) => {
        console.log(err);
      });

    //------------- METTRE LES DATAS D'ÉLIMINATION DANS setWorkData ----------------------
  }, []);

  useEffect(() => {
    setFilteredItems(filterItems());
  }, [searchTerm, triangleButton, workData]);

  function toMinutes(playTime) {
    const [hours, minutes] = playTime.split(":").map(Number);
    return hours * 60 + minutes;
  }

  const filterItems = () => {
    let filteredItems = workData;

    // Filtrer par terme de recherche
    if (searchTerm) {
      filteredItems = filteredItems.filter((item) =>
        item.handle.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    if (triangleButton.includes("FCU RANK")) {
      if (triangleButton.includes("top")) {
        filteredItems.sort((a, b) => {
          const rankA = parseInt(a.rang, 10);
          const rankB = parseInt(b.rang, 10);

          return rankA - rankB;
        });
      } else {
        filteredItems.sort((a, b) => {
          const rankA = parseInt(a.rang, 10);
          const rankB = parseInt(b.rang, 10);

          return rankB - rankA;
        });
      }
    }
    if (triangleButton.includes("PLAYER")) {
      if (triangleButton.includes("top")) {
        filteredItems.sort((a, b) => {
          return a.handle.localeCompare(b.handle);
        });
      } else {
        filteredItems.sort((a, b) => {
          return b.handle.localeCompare(a.handle);
        });
      }
    }
    if (triangleButton.includes("KILLS")) {
      if (triangleButton.includes("top")) {
        filteredItems.sort((a, b) => {
          const rankA = parseInt(a.kills, 10);
          const rankB = parseInt(b.kills, 10);

          return rankA - rankB;
        });
      } else {
        filteredItems.sort((a, b) => {
          const rankA = parseInt(a.kills, 10);
          const rankB = parseInt(b.kills, 10);

          return rankB - rankA;
        });
      }
    }
    if (triangleButton.includes("KILL / DEATH")) {
      if (triangleButton.includes("top")) {
        filteredItems.sort((a, b) => {
          const rankA = parseFloat(a.KD);
          const rankB = parseFloat(b.KD);

          return rankA - rankB;
        });
      } else {
        filteredItems.sort((a, b) => {
          const rankA = parseFloat(a.KD);
          const rankB = parseFloat(b.KD);

          return rankB - rankA;
        });
      }
    }
    if (triangleButton.includes("SCORE / MINUTE")) {
      if (triangleButton.includes("top")) {
        filteredItems.sort((a, b) => {
          const rankA = parseInt(a.scoreMinute, 10);
          const rankB = parseInt(b.scoreMinute, 10);

          return rankA - rankB;
        });
      } else {
        filteredItems.sort((a, b) => {
          const rankA = parseInt(a.scoreMinute, 10);
          const rankB = parseInt(b.scoreMinute, 10);

          return rankB - rankA;
        });
      }
    }
    if (triangleButton.includes("PLAY TIME")) {
      if (triangleButton.includes("top")) {
        filteredItems.sort((a, b) => {
          const timeA = toMinutes(a.playTime);
          const timeB = toMinutes(b.playTime);

          return timeA - timeB;
        });
      } else {
        filteredItems.sort((a, b) => {
          const timeA = toMinutes(a.playTime);
          const timeB = toMinutes(b.playTime);

          return timeB - timeA;
        });
      }
    }
    if (triangleButton.includes("RSI RANK")) {
      if (triangleButton.includes("top")) {
        filteredItems.sort((a, b) => {
          const rankA = parseInt(a.rank, 10);
          const rankB = parseInt(b.rank, 10);

          return rankA - rankB;
        });
      } else {
        filteredItems.sort((a, b) => {
          const rankA = parseInt(a.rank, 10);
          const rankB = parseInt(b.rank, 10);

          return rankB - rankA;
        });
      }
    }
    // console.log(filteredItems);
    // console.log(filteredItems.length);
    setTriangleClass("");
    return filteredItems;
  };

  const handleInputChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const clickOnEmployee = (data) => {
    const newEmployeesList = workData.filter(
      (joueur) => joueur.rang !== data.rang
    );
    setDeleteEmployee(data);
  };

  const deleteValidation = async (data) => {
    const newEmployeesList = workData.filter(
      (joueur) => joueur.rang !== data.rang
    );

    setWorkData(newEmployeesList);
    setDeleteEmployee(false);
    // console.log(data);
    // setOptionNames([...optionNames, data.Employee]);
  };

  const cancelValidation = async (data) => {
    setDeleteEmployee(false);
  };

  const resetSearchBar = (e) => {
    setSearchTerm("");
  };

  useEffect(() => {
    if (searchTerm === "") {
    }
  }, [searchTerm]);

  const onEliminationClick = () => {
    setWorkData(eliminationDatas);
    setActiveButton("elimination");
  };

  const onControlClick = () => {
    setWorkData(controlDatas);
    setActiveButton("control");
  };

  const onSquadronClick = () => {
    setWorkData(squadronDatas);
    setActiveButton("squadron");
  };

  const onVanduulClick = () => {
    setWorkData(vanduulDatas);
    setActiveButton("vanduul");
  };

  const onPirateClick = () => {
    setWorkData(pirateDatas);
    setActiveButton("pirate");
  };

  return (
    <div id="leaderboardPage" className="leaderboardPage">
      <Navbar />
      <div className="leaderboardPage__leaderboardContainer">
        <div className="container-top">
          {/* <div className="inner-container-top">
            <h1>LEADERBOARD</h1>
          </div> */}
          <div className="inner-container-middle">
            <div
              onClick={onEliminationClick}
              className={`bloc-elimination ${activeButton === "elimination" ? "active" : ""
                }`}
            >
              <p>
                Elimination
              </p>
            </div>
            <div
              onClick={onControlClick}
              className={`bloc-control ${activeButton === "control" ? "active" : ""
                }`}
            >
              <p>
                Control
              </p>
            </div>
            <div
              onClick={onSquadronClick}
              className={`bloc-squadron ${activeButton === "squadron" ? "active" : ""
                }`}
            >
              <p>
                Squadron battle
              </p>
            </div>
            <div
              onClick={onVanduulClick}
              className={`bloc-vanduul ${activeButton === "vanduul" ? "active" : ""
                }`}
            >
              <p>
                Vanduul Swarm
              </p>
            </div>
            <div
              onClick={onPirateClick}
              className={`bloc-pirate ${activeButton === "pirate" ? "active" : ""
                }`}
            >
              <p>
                Pirate Swarm
              </p>
            </div>
          </div>
        </div>
        <div
          className={`container-bottom ${filteredItems.length >= 8 ? "border-b" : ""
            }`}
        >
          <div className="inner-container-bottom">
            <input
              className="input"
              type="text"
              placeholder="Rechercher..."
              value={searchTerm}
              onChange={handleInputChange}
            />

            {searchTerm !== "" ? (
              <span onClick={resetSearchBar} className="searchbar-cross">
                <FontAwesomeIcon icon={faXmark} />
              </span>
            ) : null}

            <div className="leaderboardInformation">
              <p> Les informations sont actualisées tout les jours a 1h20, 4H40, 7h20, 10h20, 13h20, 16h20, 19h20 et 22H20. </p>
            </div>
          </div>
          <table id="action" className="table">
            <thead className="thead">
              <tr className="tr">
                {titlesArray.map((title, index) => (
                  <td key={index} className={`td td-${index}`}>
                    <div className="td-title">
                      <p>{title}</p>
                      <div className="triangle-container">
                        <div
                          className="triangle"
                          onClick={() => triangleClick(title, "top")}
                        >
                          <span>
                            <FontAwesomeIcon icon={faCaretUp} />
                          </span>
                        </div>
                        <div
                          className="triangle"
                          onClick={() => triangleClick(title, "bottom")}
                        >
                          <span>
                            <FontAwesomeIcon icon={faCaretDown} />
                          </span>
                        </div>
                      </div>
                    </div>
                  </td>
                ))}
              </tr>
            </thead>
            {workData && (
              <tbody className="tbody">
                {filteredItems.map((data, index) => (
                  <div className="relative" key={index}>
                    <tr key={index} className="row">
                      <td className="td td-0">{data.rang}</td>
                      <td className="td td-1 font-semibold">{data.handle}</td>
                      <td className="td td-2">{data.kills}</td>
                      <td className="td td-3">{data.KD}</td>
                      <td className="td td-4">{data.scoreMinute}</td>
                      <td className="td td-4">{data.playTime}</td>
                      <td className="td td-4">{data.rank}</td>
                    </tr>
                  </div>
                ))}
              </tbody>
            )}
          </table>
        </div>
      </div>
    </div>
  );
};

export default LeaderboardPage;
